<template>
    <div>
        <section class="bg-base">
            <div class="jumbotron">
                <div class="jumbotron_txtUnit ff_serif">
                    <h1 class="jumbotron_ttl">由数学協会</h1>
                    <p class="jumbotron_txtJa">
                        <span class="fz_20">史上最高</span>の<br>
                                                       &nbsp;自分になるメソッド
                    </p>
                </div>
                <p class="jumbotron_txtEn ff_serif">
                    you learn it<br>
                    for you.<br>
                    Your dream<br>
                    life<br>
                </p>
                <div class="jumbotron_art">
                    <h2 class="jumbotron_art_fonts yussugaku">yusuugaku</h2>
                    <p class="jumbotron_art_fonts creato">creato</p>
                    <p class="jumbotron_art_fonts subcon">subcon</p>
                    <p class="jumbotron_art_fonts ineividuality">ineividuality</p>
                    <p class="jumbotron_art_fonts rightbrain">rightbrain</p>
                    <p class="jumbotron_art_fonts merit">merit</p>
                    <p class="jumbotron_art_fonts reftbrain">reftbrain</p>
                    <p class="jumbotron_art_fonts selfproduce">selfproduce</p>
                    <p class="jumbotron_art_fonts statistics">statistics</p>
                    <p class="jumbotron_art_fonts communication">communication</p>
                    <p class="jumbotron_art_fonts learning">learning</p>
                    <p class="jumbotron_art_fonts past">past</p>
                    <p class="jumbotron_art_fonts suport">suport</p>
                    <p class="jumbotron_art_fonts decision">decision</p>
                    <p class="jumbotron_art_fonts welcome">welcome</p>
                    <p class="jumbotron_art_fonts thought">thought</p>
                    <p class="jumbotron_art_fonts world">world</p>
                    <p class="jumbotron_art_fonts taxonomy">taxonomy</p>
                    <p class="jumbotron_art_fonts stageup">stageup</p>
                    <p class="jumbotron_art_fonts scheme">scheme</p>
                    <p class="jumbotron_art_fonts online">online</p>
                    <p class="jumbotron_art_fonts association">association</p>
                    <p class="jumbotron_art_fonts install">install</p>
                    <p class="jumbotron_art_fonts method">method</p>
                    <p class="jumbotron_art_fonts morality">morality</p>
                    <p class="jumbotron_art_fonts private">private</p>
                    <p class="jumbotron_art_fonts success">success</p>
                    <p class="jumbotron_art_fonts license">license</p>
                    <p class="jumbotron_art_fonts sns">sns</p>
                    <p class="jumbotron_art_fonts origin">origin</p>
                    <p class="jumbotron_art_fonts counseor">counseor</p>
                    <p class="jumbotron_art_fonts trouble">trouble</p>
                    <p class="jumbotron_art_fonts program">program</p>
                    <p class="jumbotron_art_fonts update">update</p>
                    <p class="jumbotron_art_fonts school">school</p>
                    <p class="jumbotron_art_fonts output">output</p>
                    <p class="jumbotron_art_fonts proper">proper</p>
                    <p class="jumbotron_art_fonts original">original</p>
                    <p class="jumbotron_art_fonts time">time</p>
                </div>
                <!--                <picture>-->
                <!--                    <source media="(max-width: 767.98px)"-->
                <!--                            :srcset="`${dir}/src/assets/img/jumbotron-sm-1600x2080-1.3x1.webp`">-->
                <!--                    <source media="(min-width: 768px and max-width: 991.98px)"-->
                <!--                            :srcset="`${dir}/src/assets/img/jumbotron-md-2500x2000-1x0.8.webp`">-->
                <!--                    <source media="(min-width: 992px)"-->
                <!--                            :srcset="`${dir}/src/assets/img/jumbotron-lg-3000x1500-1x0.6.webp`">-->
                <!--                    <img class="jumbotron"-->
                <!--                         :src="`${dir}/src/assets/img/jumbotron-lg-3000x1500-1x0.6.webp`"-->
                <!--                         alt="">-->
                <!--                </picture>-->
            </div>
        </section>

        <section class="bg-base">
            <div class="pt-60 pb-120 pt-md-100 pb-md-200 position_relative">
                <div class="js_inview_heading el_verticalLineBox">
                    <span class="el_verticalLine"></span>
                </div>
                <h2 class="el_headingA" title="About Us">
                    由数学について
                </h2>
                <div class="contA mt-60 mt-md-100">
                    <p class="contA_txt" ref="parallaxA">
                        <span>
                            由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。
                        </span>
                        <span>
                            なぜいま、由数学が必要なのでしょうか？
                        </span>
                        <span>
                            それは、人が互いに理解し合うための方法(メソッド)がこれまでになかったからです。<br>
                            このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。
                        </span>
                        <span>
                            自分または相手の在り方・考え方・行動パターンなどを具体的に個人分析し、理解することで、コミュニケーション・ビジネス・子育てと、様々な場面で円滑な人間関係が構築できます。
                        </span>
                        <span>
                            「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。
                        </span>
                    </p>
                    <p class="contA_imgWrap">
                        <img :src="`${dir}/src/assets/img/yusuugaku-hands@2x.webp`"
                             alt=""
                             class="contA_img">
                    </p>
                </div>
            </div>
        </section>

        <section>
            <div class="container pt-60 pb-60 pt-md-100 pb-md-100 position_relative">
                <div class="js_inview_heading el_verticalLineBox">
                    <span class="el_verticalLine"></span>
                </div>
                <h2 class="el_headingA" title="Philosophy">
                    由数学3つの概念
                </h2>
                <div class="cardBUnit">
                    <div class="cardB js_inview_cardB">
                        <h3 class="cardB_ttl">
                            <span class="cardB_ttl_number js_inview_cardB_num">01</span>
                            <span class="cardB_ttl_letter js_inview_cardB_ttl">自己プロデュース</span>
                        </h3>
                        <svg class="cardB_diagonalLine" xmlns="http://www.w3.org/2000/svg" width="59.688" height="56.725" viewBox="0 0 59.688 56.725">
                            <line class="js_inview_cardB_line" data-name="line" x1="59" y2="56" transform="translate(0.344 0.363)" fill="none" stroke="#1e2e40" stroke-width="1"/>
                        </svg>
                        <p class="cardB_txt js_inview_cardB_txt">
                            自分の在り方、考え方、行動パターンを分析し最速で自己開花する方法を学びます。<br>
                            プロファイリングを行うことで、自分の変化と進化を体感します。
                        </p>
                    </div>
                    <div class="cardB js_inview_cardB">
                        <h3 class="cardB_ttl">
                            <span class="cardB_ttl_number js_inview_cardB_num">02</span>
                            <span class="cardB_ttl_letter js_inview_cardB_ttl">自立</span>
                        </h3>
                        <svg class="cardB_diagonalLine" xmlns="http://www.w3.org/2000/svg" width="59.688" height="56.725" viewBox="0 0 59.688 56.725">
                            <line class="js_inview_cardB_line" data-name="line" x1="59" y2="56" transform="translate(0.344 0.363)" fill="none" stroke="#1e2e40" stroke-width="1"/>
                        </svg>
                        <p class="cardB_txt js_inview_cardB_txt">
                            ビジネス社会において、収益化するメソッドとは必須です。<br>
                            ビジネスマネジメントの強化や、自立するための自信をつけるプロセスを学びます。
                        </p>
                    </div>
                    <div class="cardB js_inview_cardB">
                        <h3 class="cardB_ttl">
                            <span class="cardB_ttl_number js_inview_cardB_num">03</span>
                            <span class="cardB_ttl_letter js_inview_cardB_ttl">働くから楽しむの世界</span>
                        </h3>
                        <svg class="cardB_diagonalLine" xmlns="http://www.w3.org/2000/svg" width="59.688" height="56.725" viewBox="0 0 59.688 56.725">
                            <line class="js_inview_cardB_line" data-name="line" x1="59" y2="56" transform="translate(0.344 0.363)" fill="none" stroke="#1e2e40" stroke-width="1"/>
                        </svg>
                        <p class="cardB_txt js_inview_cardB_txt">
                            由数学では、カウンセラーとして活動していく中で多くの方の悩みを解決し人や社会に貢献し、同じ思いを持った仲間とともに確実に収益化しながら、喜びと感謝溢れる毎日を構築します。
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-base">
            <div class="container pt-60 pb-60 pt-md-100 pb-md-100 position_relative">
                <div class="js_inview_heading el_verticalLineBox">
                    <span class="el_verticalLine"></span>
                </div>
                <h2 class="el_headingA" title="Recommend">
                    こんな方におすすめ
                </h2>
                <div class="cardCUnit">
                    <div class="cardC js_inview_cardC">
                        <h3 class="cardC_ttl">
                            ビジネス編
                        </h3>
                        <ul class="cardC_list">
                            <li>上司とうまく付き合いたい</li>
                            <li>取引先やお客様との交渉が苦手</li>
                            <li>部下への指導、まとめ方がわからない</li>
                            <li>集客、クロージング力をつけたい</li>
                        </ul>
                    </div>
                    <div class="cardC js_inview_cardC">
                        <h3 class="cardC_ttl">
                            パートナー編
                        </h3>
                        <ul class="cardC_list">
                            <li>あの人に自分を分かってほしい</li>
                            <li>理解してくれる最良のパートナーとは</li>
                            <li>あの人と自分との相性を知りたい</li>
                            <li>パートナーとの最も幸運な時期はいつ</li>
                        </ul>
                    </div>
                    <div class="cardC js_inview_cardC">
                        <h3 class="cardC_ttl">
                            子育て編
                        </h3>
                        <ul class="cardC_list">
                            <li>子供にとってわかりやすい親になるには</li>
                            <li>子供のやる気スイッチを押したい</li>
                            <li>子供の能力を開花させたい</li>
                            <li>子供の潜在能力を知りたい</li>
                        </ul>
                    </div>
                    <div class="cardC js_inview_cardC">
                        <h3 class="cardC_ttl">
                            コミュニケーション編
                        </h3>
                        <ul class="cardC_list">
                            <li>自分の考えを上手く表現できない</li>
                            <li>相手の気持ちや表現に振り回されてしまう</li>
                            <li>相手の気持ちを理解するには？</li>
                            <li>自分を分かってくれる人ってどんな人？</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="container pt-60 pb-200 pt-md-100 pb-md-250 position_relative">
                <div class="js_inview_heading el_verticalLineBox">
                    <span class="el_verticalLine"></span>
                </div>
                <h2 class="el_headingA" title="Pre-seminar">
                    体験セミナー
                </h2>
                <div class="contD mt-60">
                    <p class="lh_2">
                        私たちは職場・恋愛・子育てと、全ては人間関係の中で成り立っています。<br>
                        一人で悩まず、由数学を活用し、ストレスフリーな毎日を過ごしませんか？
                    </p>
                    <dl class="contD_disc mt-40">
                        <dt>受講料<span>：</span></dt>
                        <dd>３,８００円</dd>
                    </dl>
                    <dl class="contD_disc mt-10">
                        <dt>時　間<span>：</span></dt>
                        <dd>２時間</dd>
                    </dl>
                    <p class="mt-15">※開催日時は、お申し込み欄に記載しています。</p>
                    <div class="el_verticalLineBox el_verticalLineBox__static el_verticalLineBox__long mt-50">
                        <span class="js_inview_line el_verticalLine"></span>
                    </div>
                    <p class="d_flex justify_content_center mt-50">
                        <router-link to="/entry-pre-seminar" class="el_btnA el_btnA__black el_btnA__large">
                            ENTRY
                        </router-link>
                    </p>
                </div>
            </div>
        </section>

        <section class="bg-base">
            <div class="container pt-60 pb-200 pt-md-100 pb-md-250 position_relative">
                <div class="js_inview_heading el_verticalLineBox">
                    <span class="el_verticalLine"></span>
                </div>
                <h2 class="el_headingA" title="Message">
                    受講生の声
                </h2>
                <div class="contE mt-60">
                    <swiper class="contEUnit" :options="swiperOption">
                        <swiper-slide class="cardE">
                            <div class="cardE_body">
                                <p class="cardE_txtA">
                                    私は普段から仕事でカウンセリングをやる機会があり、個人で事業をするなら人にカウンセリングを通して背中を押す事ができるといいな〜と思っていました。<br>
                                    由数学のお話を頂いた時、初めはどんなカウンセリングするのか想像もつきませんでした。<br>
                                    そこで、やるかやらないか別としてまずはプレセミナーに参加する事にしました。<br>
                                    プレセミナーに参加した事で、由数学とは…から全体概要、由数学がこれからの時代に求められる選ばれるカウンセリングの仕事である事を確信しました。<br>
                                    人の生まれ持った個性にフォーカスして、個々に合わせた暮らし方や対人関係、仕事のアドバイスができる由数学は、まさにサスティナブルな社会の実現にふさわしいとも思います。
                                </p>
                                <p class="cardE_txtB">沖縄県　M.Kさん</p>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="cardE">
                            <div class="cardE_body">
                                <p class="cardE_txtA">
                                    私はこれがしたい、あれがしたい。本当に明確な目標などはありませんでした。<br>
                                    ただ由数学のプレセミナーに参加して「これってみんなが知ったらすごくストレスフリーに暖かい世の中になるな」と思いました。<br>
                                    人間関係身近だったり、仕事だったら必ず誰しもが悩んだことがあることだと思います。<br>
                                    考え方が変わる、人をさらに好きになる学問だと思います。<br>
                                    参加して学んでみて良かったです。
                                </p>
                                <p class="cardE_txtB">広島県　A.Kさん</p>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="cardE">
                            <div class="cardE_body">
                                <p class="cardE_txtA">
                                    由数学って初めて聞くけどなんだろう？<br>
                                    怪しかったらどうしよう？<br>
                                    そんな半信半疑のスタートでした。<br>
                                    しかし参加してみると、<br>
                                    えっ！そういうこと！？<br>
                                    わかるー！<br>
                                    驚きと共感の連続。あっという間の2時間でした。<br>
                                    職場における同僚や上司、取引先との人間関係の作り方。人との距離の取り方。<br>
                                    子育てにおける悩み。<br>
                                    いつも他人と比べ自己肯定感の低い自分の性格。<br>
                                    なんでいつも自分はこうなんだろう…。<br>
                                    全ての人間のお悩み解決法がこの由数学にある！と思いました。<br>
                                    学び伝えることで大切な人も自分も幸せにできる。<br>
                                    由数学はまさに人間学。<br>
                                    この世界の誰もが抱える、生き方のヒントが見つかる学問だと思います。
                                </p>
                                <p class="cardE_txtB">広島県　H.Tさん</p>
                            </div>
                        </swiper-slide>
                        <div slot="pagination" class="swiper-pagination"></div>
                    </swiper>
                    <div class="el_verticalLineBox el_verticalLineBox__static el_verticalLineBox__long mt-50">
                        <span class="js_inview_line el_verticalLine"></span>
                    </div>
                    <p class="d_flex justify_content_center mt-50">
                        <router-link to="/entry-pre-seminar" class="el_btnA el_btnA__black el_btnA__large">
                            ENTRY
                        </router-link>
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {metaJsonLd} from '../assets/js/modules/meta-json-ld';
import Velocity from 'velocity-animate';

export default {
    name: "Home",
    data() {
        return {
            dir: DIR,
            swiperOption: {
                breakpoints: {
                    1200: {
                        slidesPerView: 1.4
                    },
                    768: {
                        slidesPerView: 1.2,
                        // spaceBetween: 0
                    }
                },
                slidesPerView: 1,
                speed: 1000,//スライドの切り替わりスピード
                spaceBetween: 30,//各スライドの余白
                centeredSlides: true,//スライダーを真ん中に
                loop: true, //無限ループ
                autoplay: { //スライドの自動切り替え
                    delay: 5000,//スライドの自動切り替えの秒数
                    disableOnInteraction: false//何らかのアクション後の自動切り替えを再開
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            }
        }
    },
    metaInfo() {
        return metaJsonLd(this.$store.getters['page/name']);
    },
    mounted() {
        /**
         *
         */
        this.$lax.addElement(this.$refs.parallaxA, {
            scrollY: {
                translateY: [
                    ['elInY', 'elOutY'],
                    [100, -100]
                ],
                translateZ: [
                    ['elInY', 'elOutY'],
                    [0, 0]
                ],
            }
        });
        /**
         * タイトルのinviewアニメーション
         */
        Array.prototype.slice.call(document.getElementsByClassName('js_inview_heading')).forEach(el => {
            el.style.visibility                 = 'hidden';
            el.nextElementSibling.style.opacity = 0;
            this.$store.dispatch('inview/init', {el, dividend: 1.25})
                .then(el => {
                    el.style.visibility = 'visible';
                    Velocity(el.firstElementChild, {
                        translateY: ['100%', '-100%'],
                    }, {
                        duration: 400,
                        easing: 'ease-out',
                        mobileHA: false,
                    });
                    Velocity(el.firstElementChild, {
                        translateY: [0, '-100%'],
                    }, {
                        duration: 700,
                        easing: 'ease-out',
                        mobileHA: false,
                    });
                    Velocity(el.nextElementSibling, {
                        opacity: 1,
                        translateY: [0, '-20px'],
                    }, {
                        delay: 1000,
                        duration: 700,
                        easing: 'ease-in',
                        mobileHA: false,
                    });
                });
        });

        /**
         * cardBのinviewアニメーション
         * 由数学3つの概念
         */
        Array.prototype.slice.call(document.getElementsByClassName('js_inview_cardB')).forEach(el => {
            const num  = el.getElementsByClassName('js_inview_cardB_num')[0],
                  line = el.getElementsByClassName('js_inview_cardB_line')[0],
                  ttl  = el.getElementsByClassName('js_inview_cardB_ttl')[0],
                  txt  = el.getElementsByClassName('js_inview_cardB_txt')[0];

            num.style.opacity           = 0;
            line.style.strokeDasharray  = 80 + 'px';
            line.style.strokeDashoffset = 80 + 'px';
            ttl.style.opacity           = 0;
            txt.style.opacity           = 0;

            this.$store.dispatch('inview/init', {el, dividend: 1.25})
                .then(el => {
                    Velocity(num, {
                        translateY: [0, '30px'],
                        opacity: 1,
                    }, {
                        duration: 700,
                        easing: 'ease-out',
                        mobileHA: false,
                    });
                    Velocity(line, {
                        strokeDashoffset: 0,
                    }, {
                        delay: 500,
                        duration: 400,
                        easing: 'ease-out',
                        mobileHA: false,
                    });
                    Velocity(ttl, {
                        translateY: [0, '30px'],
                        opacity: 1,
                    }, {
                        delay: 900,
                        duration: 1000,
                        easing: 'ease-out',
                        mobileHA: false,
                    });
                    Velocity(txt, {
                        translateY: [0, '30px'],
                        opacity: 1,
                    }, {
                        delay: 1100,
                        duration: 1000,
                        easing: 'ease-out',
                        mobileHA: false,
                    });
                })
        });

        /**
         * cardCのinviewアニメーション
         * こんな方におすすめ
         */
        Array.prototype.slice.call(document.getElementsByClassName('js_inview_cardC')).forEach(el => {

            el.style.opacity = 0;

            this.$store.dispatch('inview/init', {el, dividend: 1.25})
                .then(el => {
                    Velocity(el, {
                        translateY: [0, '50px'],
                        opacity: 1,
                    }, {
                        duration: 1000,
                        easing: 'ease-out',
                        mobileHA: false,
                    });
                })
        });

        /**
         * エントリーボタンの上のラインのアニメーション
         */
        Array.prototype.slice.call(document.getElementsByClassName('js_inview_line')).forEach(el => {
            el.style.visibility = 'hidden';
            this.$store.dispatch('inview/init', {el, dividend: 1.25})
                .then(el => {
                    el.style.visibility = 'visible';
                    (function velocity() {
                        Velocity(el, {
                            translateY: ['100%', '-100%']
                        }, {
                            delay: 300,
                            duration: 1400,
                            easing: 'ease-out',
                            mobileHA: false,
                            complete: velocity,
                        })
                    })();
                })
        });
    },
    beforeDestroy() {
        this.$lax.removeElement(this.$refs.parallaxA);
    },
};
</script>

<style scoped lang="scss" src="../../src/assets/scss/home.scss">
</style>
